import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { RequestFormError } from 'entities/request_form_error'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'
import { RequestFormErrorViewModel } from 'view_models/request_form_error_view_model'

export const requestFormErrorColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'request_form_error_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'ステータス', th: true, width: 100, form: form },
            {
                name: '施設名',
                th: true,
                width: 200,
                form: form,
                orderAttr: 'request_form_error_institution_id',
                searchType: { name: 'institution_name', type: 'text' },
            },
            {
                name: 'カルテ番号',
                th: true,
                align: 'center',
                width: 90,
                form: form,
                orderAttr: 'request_form_error_karte_number',
                searchType: { name: 'karte_number', type: 'text' },
            },
            {
                name: 'ユーザー名',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'request_form_error_user_name',
                searchType: { name: 'user_name', type: 'text' },
            },
            {
                name: '生年月日',
                th: true,
                width: 90,
                align: 'center',
                form: form,
                orderAttr: 'request_form_error_birthday',
                searchType: { name: 'birthday', type: 'date' },
            },
            {
                name: '依頼日',
                th: true,
                width: 90,
                align: 'center',
                form: form,
                orderAttr: 'request_form_error_request_date',
                searchType: { name: 'request_date', type: 'date' },
            },
            { name: '変更内容', th: true, width: 200 },
            { name: '対応者', th: true, width: 120 },
            {
                name: '確認日',
                th: true,
                width: 90,
                align: 'center',
                form: form,
                orderAttr: 'request_form_error_confirmation_date',
                searchType: { name: 'confirmation_date', type: 'date' },
            },
            { name: '確認者', th: true, width: 120 },
            { name: '備考', th: true, width: 300, form: form, orderAttr: 'request_form_error_note', searchType: { name: 'note', type: 'text' } },
        ],
    }
}

export type RequestFormErrorTableDataProps = {
    requestFormError?: RequestFormError
    displaySetting: DisplaySetting
}

export const RequestFormErrorTableData = ({ requestFormError, displaySetting }: RequestFormErrorTableDataProps): JSX.Element => {
    if (!requestFormError) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new RequestFormErrorViewModel(requestFormError)
        return (
            <>
                <TableCell>{requestFormError.id}</TableCell>
                <TableCell align="center">
                    {!requestFormError.correspondingUser?.fullName ? (
                        <Badge bg="danger">対応待ち</Badge>
                    ) : !requestFormError.confirmationUser?.fullName ? (
                        <Badge bg="warning">確認待ち</Badge>
                    ) : (
                        <Badge bg="success">完了</Badge>
                    )}
                </TableCell>
                <TableCell>{requestFormError.institution?.name}</TableCell>
                <TableCell align="center">{requestFormError.karteNumber}</TableCell>
                <TableCell>{requestFormError.userName}</TableCell>
                <TableCell align="center">{toDateText(requestFormError.birthday)}</TableCell>
                <TableCell align="center">{toDateText(requestFormError.requestDate)}</TableCell>
                <TableCell>
                    <div>
                        {Object.keys(vm.items()).map((key, index) => {
                            const value = vm.items()[key]
                            return (
                                <div key={'error-item-' + index}>
                                    {key}: {value ? value : <Badge bg="secondary">確認中</Badge>}
                                </div>
                            )
                        })}
                    </div>
                </TableCell>
                <TableCell>{requestFormError.correspondingUser?.fullName}</TableCell>
                <TableCell align="center">{toDateText(requestFormError.confirmationDate)}</TableCell>
                <TableCell>{requestFormError.confirmationUser?.fullName}</TableCell>
                <TableCell>{requestFormError.note}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
